import { createContext, useContext } from 'react';
import { FeedbackDrawerModel } from '~/model/model.feedback.drawer';

export const FeedbackDrawerContext = createContext<FeedbackDrawerModel>(null!);

export const useFeedbackDrawerContext = () => {
	return useContext(FeedbackDrawerContext);
};
